'use client';

import React from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import Link from 'next/link';

import { PersonIcon } from '@rescui/icons';

import IaButton from '@/components/common/webteam/IaButton/IaButton';
import IaMenuItem from '@/components/common/webteam/IaMenuItem/IaMenuItem';
import { UserRole } from '@/enums/users';
import { useStores } from '@/hooks';

import styles from './ProfileButton.module.scss';

type Props = {
  onClick?: () => void;
};

const ProfileButton: React.FC<Props> = ({ onClick }) => {
  const { userStore } = useStores();
  const me = userStore.me;

  if (me?.role !== UserRole.STUDENT || !me.studentprofile) {
    return null;
  }

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <Link href="/profile" onClick={handleClick}>
      <IaButton
        className={clsx(styles.button, styles.__withPhoto)}
        icon={me.photo ? <img alt="photo" src={me.photo} /> : <PersonIcon />}
        mode="outline"
        size="m"
        theme="dark"
        onClick={handleClick}
      ></IaButton>

      <IaMenuItem className={styles.dropdownMenuItem} onClick={handleClick}>
        Profile
      </IaMenuItem>
    </Link>
  );
};

export default observer(ProfileButton);
